// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".next-arrow,.prev-arrow{--bg-opacity:1;background-color:#a76052;background-color:rgba(167,96,82,var(--bg-opacity));cursor:pointer;border-radius:9999px;display:flex;align-items:center;justify-content:center;z-index:20;position:absolute}.slick-disabled .next-arrow,.slick-disabled .prev-arrow{opacity:0;cursor:default}", ""]);
// Exports
module.exports = exports;
